import React, { useMemo, useEffect, useCallback } from 'react'
import useGetData from 'hooks/useGetData'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useBoardDataProvider } from 'dataProviders/Board'

const TemplateField: React.FC<{
  boardId: number
  value?: string
  onChange?: (value: string) => void
  emptyTitle?: string
}> = ({
  boardId,
  value,
  onChange,
  emptyTitle,
}) => {
  const args = useMemo(() => ({
    boardId
  }), [boardId])
  const {
    data,
  }: {
    data: any
  } = useGetData('CardTemplates', args)

  const { isReady: isBoardReady } = useBoardDataProvider({ id: boardId })

  const cardTemplateId = useSelector(state => isBoardReady ? state['view-board'].settings[boardId].cardTemplateId : undefined)

  useEffect(() => {
    if (data && !value && isBoardReady) {
      if (cardTemplateId && data.Templates.find(Template => Template.Id === cardTemplateId)) {
        onChange?.(String(cardTemplateId))
      } else {
        onChange?.('empty')
      }
    }
  }, [boardId, data, value, isBoardReady, cardTemplateId])

  const handleChange = useCallback((event) => {
    onChange?.(event.target.value)
  }, [onChange])

  const sortedTemplates = useMemo<any[]>(() => {
    if (data) {
      return data.Templates.sort((a, b) => a.Position - b.Position)
    }

    return []
  }, [data])

  return isBoardReady && sortedTemplates.length > 0 ? (
    <FormGroup>
      <ControlLabel><FormattedMessage id='CARD_TEMPLATE' /></ControlLabel>
      <FormControl
        value={value}
        onChange={handleChange}
        componentClass='select'
      >
        {emptyTitle ? (
          <option value='empty'>{emptyTitle}</option>
        ) : (
          <FormattedMessage id='CARD_TEMPLATE_SELECT_NONE'>
            {(formattedMessage) => (
              <option value='empty'>{formattedMessage}</option>
            )}
          </FormattedMessage>
        )}
        {sortedTemplates.map(Template =>
          <option
            key={Template.Id}
            value={Template.Id}
          >
            {Template.Name}
          </option>
        )}
      </FormControl>
    </FormGroup>
  ) : null
}

export default TemplateField
